<template>
  <li
    class="group cursor-pointer flex gap-3 items-center justify-start data-[active]:bg-neutral-100 data-[active]:ring-1 data-[active]:ring-neutral-200 rounded-xl p-2"
    @click.prevent.stop="handleClick(item)"
    @keydown.enter.prevent="handleClick(item)"
    @mouseenter="setIndex(index)"
    @focus="setIndex(index)"
  >
    <div class="bg-neutral-200 rounded-xl size-10 items-center justify-center shrink-0 hidden @[16rem]:flex">
      <img
        v-if="item?.uri_thumbnail"
        :src="item?.uri_thumbnail"
        alt="Vetster"
        class="rounded-xl"
      />
      <fa
        v-else
        :icon="getIcon"
        class="text-xl select-none pointer-events-none text-neutral-500"
      />
    </div>
    <div class="grow flex flex-col">
      <div
        class="text-sm line-clamp-1"
        v-html="titleHtml(item)"
      />
      <div class="text-xs text-neutral-500 line-clamp-1">
        {{ hierarchy }}
      </div>
    </div>
    <div class="px-1 hidden @[16rem]:block">
      <fa
        v-if="isLoadingResult && getLoadingResultIndex === index"
        :icon="['fal', 'circle-notch']"
        class="text-xl select-none pointer-events-none fa-spin group-[[data-active]]:translate-x-1 transition-transform"
      />
      <fa
        v-else
        :icon="['fal', 'arrow-right']"
        class="text-xl select-none pointer-events-none group-[[data-active]]:translate-x-1 transition-transform"
      />
    </div>
  </li>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faArrowRight,
  faCircleNotch,
} from '@fortawesome/pro-light-svg-icons';

import InteractsWithGlobalSearch from '@/mixins/InteractsWithGlobalSearch';

library.add({
  faArrowRight,
  faCircleNotch,
});

export default {
  name: 'VetsterGlobalSearchTile',

  mixins: [InteractsWithGlobalSearch],

  props: {
    index: {
      type: Number,
      default: 0,
    },
    item: {
      type: Object,
      default: () => ({}),
    },
  },

  emits: ['click'],

  computed: {
    hierarchy() {
      return Object.values(this.item.hierarchy).map((level) => level.name).join(' • ');
    },
    getIcon() {
      return this.item?.icon || ['fal', 'paw'];
    },
  },

  methods: {
    handleClick(item) {
      if (!this.isLoadingResult) {
        this.$emit('click', item);
        if (item?.url) {
          this.setLoadingResult(this.index);
          window.location.href = item.url;
          setTimeout(() => {
            this.$store.commit('globalSearch/resetIndex');
          }, 100);
        }
      }
    },
    titleHtml(item) {
      return item.title;
    },
  },
};
</script>
